import { useEffect, useState } from "react";
import axios from "axios";
import { registerAdSpots } from "@/data/planner";

const API = process.env.REACT_APP_BACKEND_URL;

let _cache = null; // { ads: [...] }
let _inflight = null;

export async function loadActiveAds() {
  if (_cache) return _cache.ads;
  if (!_inflight) {
    _inflight = axios
      .get(`${API}/api/ads/active`)
      .then((r) => {
        _cache = { ads: r.data.ads || [] };
        registerAdSpots(_cache.ads); // make tier 2+ ads selectable in the planner
        return _cache.ads;
      })
      .catch(() => {
        _cache = { ads: [] };
        return [];
      });
  }
  return _inflight;
}

// React hook — returns the list of active advertiser listings.
export function useActiveAds() {
  const [ads, setAds] = useState(_cache ? _cache.ads : []);
  useEffect(() => {
    let alive = true;
    loadActiveAds().then((list) => {
      if (alive) setAds(list);
    });
    return () => {
      alive = false;
    };
  }, []);
  return ads;
}

export const adsForArea = (ads, areaId) => ads.filter((a) => a.area === areaId);
export const adsForCategory = (ads, category) => ads.filter((a) => a.category === category);
export const featuredAds = (ads) => ads.filter((a) => a.tier >= 3 && a.type !== "banner");
export const bannerAd = (ads) => ads.find((a) => a.type === "banner") || null;
export const adMarkers = (ads) =>
  ads
    .filter((a) => Array.isArray(a.coords))
    .map((a) => ({
      coords: a.coords,
      name: a.business_name,
      tag: `Sponsored · ${a.category}`,
      color: "#F59E0B",
      label: "Ad",
    }));
